import useApi from 'shared/library/use-api';
import useInboxStore from 'shared/state/inbox';
import { Text } from 'shared/components/text';
import { useEffectOnce } from 'shared/library/use-effect-once';
import { View } from 'react-native';
import { Props } from 'shared/@types';
import { loadUnreadCount } from 'shared/components/chat/load-unread-count';

export function UnreadCount({ className, loadInitial }: Props<{ loadInitial?: boolean }>) {
  const { request } = useApi();
  const unreadCount = useInboxStore((state) => state.unreadCount);
  const setUnreadCount = useInboxStore((state) => state.setUnreadCount);

  useEffectOnce(() => {
    if (loadInitial && unreadCount === null) {
      void loadUnreadCount(request, setUnreadCount);
    }
  });

  if (!unreadCount) {
    return null;
  }

  return (
    <View
      className={`border-brand-cream-light size-5 items-center justify-center rounded-full border-2 bg-red-600 ${className}`}
    >
      <Text className={'text-2xs font-bold text-white'}>{unreadCount}</Text>
    </View>
  );
}
